import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconArrowDown = createIcon({
  displayName: 'IconArrowDown',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M13 15.76L12 16.76L11 15.76V2H13V15.76ZM3.28998 13.71L12 22.41L20.71 13.71L19.29 12.29L12 19.59L4.70998 12.29L3.28998 13.71Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
